import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'

const ValidarPassword = (props) => {
  const formSchema = Yup.object().shape({
    password: Yup.string()
      .required('A palavra-passe é obrigatória.')
      .min(13, 'A palavra-passe tem de ter pelo menos 13 caracteres.')
      .matches("(?=[A-Za-z0-9@#$%&+-._;*!?=~^()|{}:<>,/]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%&+-._;*!?=~^()|{}:<>,/])(?=.{13,}).*$", "A palavra-passe tem de ter obrigatoriamente uma maiúscula, uma minúscula, um dígito e um caracter especial."),
    passwordConfirm: Yup.string()
      .required('Tem de repetir a palavra-passe.')
      .oneOf([Yup.ref('password')], 'As palavras-passe não são iguais.'),
  })
  const formOptions = { resolver: yupResolver(formSchema), mode:"onChange" }

  const { register, handleSubmit, formState: { errors, isValid } } = useForm(formOptions);

  const isButtonEnabled = isValid

  let navigate = useNavigate(); 
  const redirectToHelp = () =>{ 
    navigate('/ajuda');
  }

  return (
  <div className="mt-5">
    <p className="h4 mb-4">Olá, {props.name}.</p>
    <form onSubmit={handleSubmit(props.onSubmitHandler)}>
      <div className="form-group">
        <label>Palavra-passe</label>
        <input type="password" {...register("password")} className={`form-control ${errors.password ? 'is-invalid' : ''}`} />
        <div className="invalid-feedback">{errors.password?.message}</div>
      </div>
      <div className="form-group mt-4">
        <label>Repetir palavra-passe</label>
        <input type="password" {...register("passwordConfirm")} className={`form-control ${errors.passwordConfirm ? 'is-invalid' : ''}`} />
        <div className="invalid-feedback">{errors.passwordConfirm?.message}</div>
      </div>
      <div className="mt-5">
        <button type="submit" className="btn btn-primary me-4" disabled={!isButtonEnabled}>
          Continuar
        </button>
        <button type="button" className="btn btn-secondary" onClick={() => redirectToHelp()} >
          Pedir ajuda
        </button>
      </div>
    </form>
  </div>
  );
};

export default ValidarPassword;
